import React from "react";
import { PlayIcon, CheckIcon } from "./icons";

/*
 * Status chips per brief §8.2 / showcase §07 — the rhythm layer's semantic vocabulary.
 * Every state pairs color with text or an icon; never color alone.
 *   countdown → secondary badge ("in 4 days")
 *   today     → primary badge, bold
 *   live      → Error Red solid + pulsing dot (1.6s; off under reduced motion)
 *   soon      → error-tint badge
 *   new       → Sky Blue solid
 *   progress  → play glyph + N%
 *   completed → success tint + check
 * `size="sm"` renders the compact 10px variant used on small cards.
 */

const KINDS = {
  countdown: "bg-ic-lightGray text-ic-body font-semibold",
  today: "bg-ic-blue text-white font-bold",
  live: "bg-ic-error text-white font-bold",
  soon: "bg-[rgba(228,29,29,0.1)] text-ic-error font-semibold",
  new: "bg-ic-sky text-white font-bold",
  progress: "bg-ic-lightGray text-ic-blue font-bold",
  completed: "bg-[rgba(36,154,26,0.1)] text-ic-success font-bold",
};

const SIZES = {
  md: "text-[12px] leading-4 px-3 py-1",
  sm: "text-[10px] leading-[14px] px-2 py-0.5",
};

export default function StatusChip({ kind = "countdown", size = "md", className = "", children, ...rest }) {
  const iconSize = size === "sm" ? 8 : 10;
  return (
    <span
      className={`inline-flex items-center gap-1 tracking-[0.5px] rounded-xl whitespace-nowrap ${KINDS[kind] || KINDS.countdown} ${SIZES[size] || SIZES.md} ${className}`}
      {...rest}
    >
      {kind === "live" && (
        <span
          className="w-2 h-2 rounded-full bg-white animate-ic-live-pulse motion-reduce:animate-none"
          style={size === "sm" ? { width: 6, height: 6 } : undefined}
          aria-hidden="true"
        />
      )}
      {kind === "progress" && <PlayIcon size={iconSize} />}
      {kind === "completed" && <CheckIcon size={iconSize} />}
      {children}
    </span>
  );
}
